<div class="modal-header px-4 justify-content-between">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <div>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    ></button>
  </div>
</div>

<div class="modal-body my-2">
  @if(configs.type === 'copy') {
  <div>
    <div class="mb-2" *ngIf="configs.suiteName !==''">
      <span class="header-12">Copying a script from </span>
      <span class="header-12 suite-name">{{ configs.suiteName }}</span>
    </div>
  <div class="mb-2">
    <span class="header-12"
    >Please choose whether to
    <span class="header-12 fw-bold">add it to an existing test suite</span> or
  </span>
  <span class="header-12 fw-bold">
    keep it as an individual test script.</span
  >
  </div>

    <!-- radio button, test suite dropdown -->
    <div class="d-flex mt-3 align-items-center flex-row gap-2">
      <input
      type="radio"
      value="keepIndividual"
      name="storyDriven"
      [(ngModel)]="activeType"
    />
    <span> Keep as an individual test script </span>
    </div>
    <div class="d-flex mt-2 align-items-center flex-row  gap-2 mb-3">
      <input
      type="radio"
      value="moveToSuite"
      name="storyDriven"
      [(ngModel)]="activeType"
    />
    <span> Move to a test suite </span>
    </div>

    @if(activeType === 'moveToSuite') {
    <div class="mt-3 mb-3">
      <label class="form-label general-text-6"> Select Test Suite </label>
      <select
        [(ngModel)]="selectedSuite"
        aria-placeholder="Select an option"
        class="form-select mb-2"
        (change)="onSelectChange()"
      >
        @for (item of suites; track item?.value) {
        <option [value]="item.value">{{ item.label }}</option>
        }
      </select>
    </div>
    }
  </div>
  } @else {
  <div class="mb-3" *ngIf="configs.suiteName !==''">
    <span class="header-12">Duplicate a script from </span>
    <span class="header-12 suite-name">{{ configs.suiteName }}</span>
  </div>
  }

  <div >
    <span class="header-12"
      >Please provide a name for the new script below to continue.</span>
    <label class="form-label general-text-6 mt-2">
      Enter Script Name
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="scriptName"
      [placeholder]="placeholder || ''"
    />
  </div>

  <div>
    <span class="text-danger" *ngIf="isError">{{ errorMessage }}</span>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn btn-accello-primary-light"
      (click)="duplicateOrCopy()"
      [disabled]="isLoading || !scriptName"
    >
      <span>{{ configs.saveBtn }}</span>
      <span
      *ngIf="isLoading"
      class="spinner-border spinner-border-sm mx-2"
      role="status"
      aria-hidden="true"
    >
    </span>
    </button>
  </div>
</div>
